export default "/images/git-merge.svg?bea3f02bc551620cdd8bd56cd51e1d88";